export default function beginCheckout() {
    let popup = $('#infoPopUp');
    let popupCloseBtn = $('.js-popup-close');
    let checkoutBtn = $('.js-begin-checkout');

    popupCloseBtn.on('click', closePopup);

    function openPopup() {
        popup.show();
    }
    function closePopup() {
        popup.hide();
        checkoutBtn.removeClass('disabled');
    }

    checkoutBtn.on('click', function (event) {
        event.preventDefault();

        const href = $(this).attr('href');

        $.ajax({
            url: '/umbraco/Surface/Basket/GetBasket',
            type: 'GET',
            success: async function (data) {
                if (minimumPurchaseAmount > data.TotalSum) {
                    openPopup();
                    return;
                }

                window.location.href = href;
            }
        });
    });
}
